import vue2Dropzone from 'vue2-dropzone';

import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
  name: 'addFileForm',
  validTypes: ['zip'],
  components: {
    vueDropzone: vue2Dropzone,
  },
  data () {
    return {
      ModalVisibilityVar: true,
      dropzoneOptions: {
        url: this.$store.getters.rootAPI + '/parseproject',
        thumbnailWidth: 150,
        maxFilesize: 2.5,
        acceptedFiles: '.xml,.sdlppx,.zip',
        headers: { 'My-Awesome-Header': 'header value' },
        maxFiles: 1,
        success: (file, response) => {
          var jsonResponse = JSON.parse(file.xhr.response);

          if (file.status === 'success') {
            this.$store.dispatch('ADD_PROJECT', response);
            this.$emit('createForm');
          } else {
            this.$refs.myVueDropzone.dropzone.removeFile(file);
            alert(jsonResponse.message);
          }
        },
        dictDefaultMessage: '<b>Choose</b> a file or <b>drag</b> it here <br> (*.xml, *.sdlppx, *.zip, max size 15mb)',
        error: (file, response) => {
          this.$refs.myVueDropzone.dropzone.removeFile(file);
          this.$root.$emit('notification', {
            message: 'Error has occured by uploading the project file! Please, check it format and size.',
            type: 'error',
            show: true,
          });
        },
      },
    };
  },
};
